import React from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  IconButton,
  FormLabel,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";

const AuthorForm = ({ authors, setAuthors }) => {
  const handleAddAuthor = () => {
    setAuthors([...authors, { given: "", family: "" }]);
  };

  const handleInputChange = (index, fieldName, value) => {
    const updatedAuthors = [...authors];
    updatedAuthors[index][fieldName] = value;
    setAuthors(updatedAuthors);
  };

  const handleDeleteAuthor = (index) => {
    // If it's the first item, don't allow deletion
    if (index === 0) {
      return;
    }

    const updatedAuthors = authors.filter((_, i) => i !== index);
    setAuthors(updatedAuthors);
  };

  return (
    <Box>
      <FormLabel>Authors</FormLabel>
      {authors?.map((author, index) => (
        <div
          key={index}
          id={index}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.6rem",
            margin: "0.5rem 0 ",
          }}>
          <TextField
            id={index + "firstName"}
            label="First Name"
            value={author.given}
            onChange={(e) => handleInputChange(index, "given", e.target.value)}
            required
          />
          <TextField
            id={index + "lastName"}
            label="Last Name"
            value={author.family}
            onChange={(e) => handleInputChange(index, "family", e.target.value)}
            required
          />

          {index > 0 && (
            <IconButton
              id={index + "btn"}
              variant="contained"
              onClick={() => handleDeleteAuthor(index)}
              color="error">
              <CancelIcon />
            </IconButton>
          )}
        </div>
      ))}
      <Box>
        <Button onClick={handleAddAuthor} startIcon={<AddIcon />}>
          Add Another Author
        </Button>
      </Box>
    </Box>
  );
};

export default AuthorForm;
